import styled from 'styled-components';

export const StyledAccountWrapper = styled.div`
  width: 100%;
  p {
    margin: ${({ theme }) => `${theme.spacing['xl']} 0`};
  }
  @media (max-width: 325px) {
    button {
      width: 100%;
    }
  }
`;
